(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gr-product-tabs')) {
    customElements.define('gr-product-tabs', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => this.select(i));
          tab.addEventListener('keydown', (e) => {
            let next = null;
            if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
            if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
            if (next !== null) { e.preventDefault(); this.select(next, true); }
          });
        });
      }
      select(index, focus) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on);
          tab.tabIndex = on ? 0 : -1;
          const panel = this.querySelector('#' + tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && focus) tab.focus();
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
